import { render } from "./VpcTiersTab.vue?vue&type=template&id=254a7c2b&scoped=true"
import script from "./VpcTiersTab.vue?vue&type=script&lang=js"
export * from "./VpcTiersTab.vue?vue&type=script&lang=js"

import "./VpcTiersTab.vue?vue&type=style&index=0&id=254a7c2b&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254a7c2b"]])

export default __exports__